import styled from '@emotion/styled';
import AquillaButton from 'aquilla/core/molecules/Button';
import pushRoute from '@utils/pushRoute';
import { Fonts, mediaQuery, Spacings } from '@styles/index';

const QUIZ_ROUTE = '/upsc-current-affairs/quiz';
const MONTHLY_PDF_ROUTE = '/upsc-current-affairs/monthly-pdf';

const ActionsWrapper = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    justify-content: end;
    gap: ${Spacings.SPACING_2B};
  }
`;

const HeaderCTA = styled(AquillaButton)`
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_5B};
  min-width: 104px;
  height: 40px;
  border-radius: ${Spacings.SPACING_6};
  font-weight: 600;
  font-size: ${Fonts.SMALL};
  line-height: ${Spacings.SPACING_4B};
  white-space: nowrap;
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_4B};
    height: 32px;
    min-width: 64px;
    width: unset;
  }
`;

const TakeQuizCTA = styled(HeaderCTA)`
  background-color: var(--color-i-green);
  border-color: var(--color-i-green);
  color: var(--color-base-0);

  &:hover {
    background-color: var(--color-i-green-focus);
    border-color: var(--color-i-green-focus);
  }
`;

const UpscCurrentAffairsActions = () => (
  <ActionsWrapper>
    <HeaderCTA variant="secondary" onClick={() => pushRoute(MONTHLY_PDF_ROUTE)}>
      Free PDF
    </HeaderCTA>
    <TakeQuizCTA onClick={() => pushRoute(QUIZ_ROUTE)}>Take Quiz</TakeQuizCTA>
  </ActionsWrapper>
);

export default UpscCurrentAffairsActions;
